module.exports = __webpack_public_path__ + "img/couverture-2.c12517a2.png";